import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

export interface YocoCheckoutRequest {
    amount: number;
    currency: string;
    groupId: string;
    billingDocumentId?: string;
    metadata?: any;
}

export interface YocoCheckoutResponse {
    id: string;
    redirectUrl: string;
    status: string;
    amount: number;
    currency: string;
    paymentId: string | null;
    metadata: any;
}

export interface YocoPaymentStatus {
    id: string;
    status: string;
    amount: number;
    currency: string;
    metadata: any;
}

@Injectable({
    providedIn: 'root'
})
export class YocoService {
    private apiUrl = 'api';

    constructor(private http: HttpClient) { }

    createCheckout(request: YocoCheckoutRequest): Observable<YocoCheckoutResponse> {
        const token = localStorage.getItem('token');
        return this.http.post<YocoCheckoutResponse>(`${this.apiUrl}/yoco/checkout`, request, {
            headers: { Authorization: `Bearer ${token}` }
        });
    }

    getPaymentStatus(paymentId: string, groupId: string): Observable<YocoPaymentStatus> {
        const token = localStorage.getItem('token');
        return this.http.get<YocoPaymentStatus>(`${this.apiUrl}/yoco/payment/${paymentId}/${groupId}/status`, {
            headers: { Authorization: `Bearer ${token}` }
        });
    }

    generatePaymentUrl(amount: number, groupId: string, billingDocumentId?: string): Observable<string> {
        const request: YocoCheckoutRequest = {
            amount: Math.round(amount * 100), // Convert to cents
            currency: 'ZAR',
            groupId,
            billingDocumentId,
            metadata: {
                invoiceNumber: billingDocumentId ? billingDocumentId : undefined
            }
        };

        return new Observable(observer => {
            this.createCheckout(request).subscribe({
                next: (response) => {
                    observer.next(response.redirectUrl);
                    observer.complete();
                },
                error: (error) => {
                    observer.error(error);
                }
            });
        });
    }
} 